import { useMemo } from 'react';

interface UseNotFoundGuardOptions {
  loading: boolean;
  id?: string;
  entity: unknown;
}

/**
 * Returns true when a record was expected (non-new, non-empty id) but was not
 * returned by the API after loading completed — meaning it has been deleted or
 * never existed.
 *
 * Usage:
 *   const isNotFound = useNotFoundGuard({ loading: query.loading, id, entity: asset });
 */
const useNotFoundGuard = ({ loading, id, entity }: UseNotFoundGuardOptions): boolean => {
  return useMemo(() => {
    const isNew = !id || id === 'new';
    return !loading && !isNew && entity == null;
  }, [loading, id, entity]);
};

export default useNotFoundGuard;
